(function() {
    'use strict';
    angular.module('login')
        .component('login', {
            bindings: {},
            templateUrl: '/login/views/login.html',
            controller: [
                '$rootScope',
                'Bridge',
                'configuration',
                'ContentAttributeService',
                'FacilitySettingsService',
                'GatewayFactory',
                'gettext',
                'LocalStorageRepository',
                'FpSearchService',
                'SessionService',
                'TransitionManager',
                'MultipleUserAccountsError',
                Login
            ],
        });

    function Login(
        $rootScope,
        Bridge,
        configuration,
        ContentAttributeService,
        FacilitySettingsService,
        GatewayFactory,
        gettext,
        LocalStorageRepository,
        FpSearchService,
        SessionService,
        TransitionManager,
        MultipleUserAccountsError
    ) {
        var vm = this;
        vm.errorMessage = '';
        vm.submitted = false;
        vm.loading = false;
        vm.loadingAssistance = false;
        vm.loginAssistanceInfo = null;
        vm.model = {};
        vm.practiceName = null;
        vm.selectUserMode = false;

        vm.$onInit = $onInit;
        vm.login = login;

        function $onInit() {
            vm.model = {
                clientID: LocalStorageRepository.getClientID() || '0',
                username: LocalStorageRepository.getUserName() || '',
                userId: LocalStorageRepository.getUserID() || null,
                password: '',
                gateway: null,
            };

            vm.gateways = _.map(_.cloneDeep(configuration.GATEWAYS), function(g) {
                g.display = g.prefix + ' - ' + g.url;
                return g;
            });

            if(!configuration.DEV_HOSTED) {
                ContentAttributeService.getClientConfig()
                    .then(function(data) {
                        var oldClientId = LocalStorageRepository.getClientID();
                        var newClientId = data.clientId;
                        if(oldClientId !== newClientId) {
                            LocalStorageRepository.clearAll();
                        }
                        LocalStorageRepository.setClientURL(data.hostUrl);
                        LocalStorageRepository.setClientID(newClientId);
                        vm.model.clientID = newClientId;
                    })
                    .catch(function() {
                        vm.errorMessage = gettext('Error loading page. Unknown Client Id');
                        Bridge.createModalAlert({
                            title: gettext('Loading Error'),
                            message: vm.errorMessage,
                            buttons: [gettext('Okay')]
                        });
                    });
            }
        }

        function login() {
            vm.errorMessage = null;
            vm.loading = true; // turns on loading symbol
            var userId = vm.selectUserMode ? vm.model.userId : null;
            GatewayFactory.login(vm.model.clientID, vm.model.username, vm.model.password, vm.model.gateway ? vm.model.gateway.prefix : null, userId)
                .then(function() {
                    FacilitySettingsService.getSettings(true)
                        .then(function (data) {
                            if (data && data.UserSetting){
                                FpSearchService.clearLastSearch();
                                if (SessionService.getNewPasswordRequired() === true) {
                                    TransitionManager.transition({appRoute: 'changepassword'});
                                }
                                else {
                                    $rootScope.$broadcast('IdleStartWatch');
                                    TransitionManager.transition({
                                        appRoute: 'home'
                                    });
                                }
                            }
                            else {
                                vm.errorMessage = 'Facility portal settings invalid,\n contact practice';
                        }
                    })
                    .catch( function(err) {
                        vm.errorMessage = err.message;
                        Bridge.createModalAlert({
                            title: gettext('Facility portal settings invalid,\n contact practice'),
                            message: err.message,
                            buttons: [gettext('Okay')]
                        });
                    });
                })
                .catch(function(err) {
                    if(err instanceof MultipleUserAccountsError) {
                        vm.selectUserMode = true;
                        vm.userOptions = err.userOptions;
                    }
                    else {
                        vm.errorMessage = err.message;

                        Bridge.createModalAlert({
                            title: gettext('Login Error'),
                            message: err.message,
                            buttons: [gettext('Okay')]
                        });
                    }
                })
                .finally(function() {
                    vm.loading = false;
                });
        }
    }
})();